import { useEffect, useState } from "react";

export const useDynamicMenuPosition = (isOpen, parentRef, threshold = 300) => {
  const [isOpenUpwards, setIsOpenUpwards] = useState(false);

  useEffect(() => {
    if (isOpen && parentRef.current) {
      const rect = parentRef.current.getBoundingClientRect();
      const spaceBelow = window.innerHeight - rect.bottom;
      const spaceAbove = rect.top;

      setIsOpenUpwards(spaceBelow < threshold && spaceAbove > spaceBelow);
    }
  }, [isOpen, parentRef, threshold]);

  const dynamicLocation = {
    anchorOrigin: {
      vertical: isOpenUpwards ? "top" : "bottom",
      horizontal: "left",
    },
    transformOrigin: {
      vertical: isOpenUpwards ? "bottom" : "top",
      horizontal: "left",
    },
  };
  return { dynamicLocation, isOpenUpwards };
};
